// DEV: firebase deploy --only hosting:multinom-dev-gem (compila con --configuration development)
export const environment = {
  production: false,
  apiUrl: 'https://dev-api.multinom.com.mx',
  loginUrl: 'https://dev.multinom.com.mx',
  cveModulo: 'GEM',
  // Logos e iconos de la encuesta vienen como ruta relativa a esta carpeta.
  uploadUrl: 'https://bkd.multinom.app/multinom.app/uploads/',
};
